import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, UpdateDateColumn } from "typeorm";
import { AbstractEntity } from "../../../database/common-entities/abstract.entity";
import { AuthenticationEntity } from "./authentications.entity";

@Entity('ums_session_logs')
export class SessionLogEntity extends AbstractEntity {

    @Column({ name: 'auth_id', type: 'int' })
    authId: number;

    @ManyToOne(() => AuthenticationEntity)
    @JoinColumn({ name: 'auth_id' })
    authentication: AuthenticationEntity;

    @Column({ name: 'session_token', type: 'varchar', length: 500, nullable: true })
    sessionToken: string;

    @Column({ name: 'ip_address', type: 'varchar', length: 45, nullable: true })
    ipAddress: string;

    @Column({ name: 'user_agent', type: 'text', nullable: true })
    userAgent: string;

    @CreateDateColumn({ name: 'login_time' })
    loginTime: Date;

    @Column({ name: 'logout_time', type: 'datetime', nullable: true })
    logoutTime: Date;

    @UpdateDateColumn({ name: 'last_activity' })
    lastActivity: Date;

    @Column({ name: 'platform', type: 'varchar', length: 50, nullable: true })
    platform: string;

    @Column({ name: 'browser', type: 'varchar', length: 50, nullable: true })
    browser: string;

    @Column({ name: 'os', type: 'varchar', length: 50, nullable: true })
    os: string;

    @Column({ name: 'login_photo', type: 'longtext', nullable: true })
    loginPhoto: string;
}
